import { mapCollection } from '../../utils/collection.utils';
import { UserRole } from '../user-role';

export class UserRoleBuilder {
  static fromJson(json): UserRole {
    return (json)
      ? new UserRole(
        json.hash,
        json.name,
        json.isUser,
        json.isRole
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(UserRoleBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-role.builder.ts